// Generated from scripts/focus-origin.ts. Rebuild with pnpm scripts:build.
"use strict";
/*
 * The focus origin owner: marks a control that a click or a tap focused, so its focus ring stays hidden.
 *
 * `:focus-visible` follows the last input, not the way focus arrived. A clicked link or button holds focus without a
 * ring, and Chrome and Firefox ring it at the shopper's next key press, an arrow or the space bar to scroll included,
 * so the header logo and every other clicked control lit up long after the click. The ring answers "where is focus",
 * which a keyboard user asks only of focus their keyboard moved.
 *
 * - A pointer press marks the control that takes focus from it with `data-pointer-focus` until it loses focus. The
 *   stylesheet drops the ring of a marked control (`styles/wontio.css`, base layer), however the control draws it.
 * - A key press ends pointer mode, so focus that a key moves, Tab or a script reacting to a key, is never marked and
 *   rings as before.
 * - Text fields, selects and other inputs are never marked: the browser rings them on click by design, because the
 *   shopper types into the focused field.
 *
 * The module has no element and no teardown: its listeners belong to the page and start once.
 */
const MARKER = 'data-pointer-focus';
/** Controls that keep the browser's own ring on click. */
const NATIVE_RING = 'input, textarea, select, [contenteditable]:not([contenteditable="false"])';
let pointerMode = false;
document.addEventListener('pointerdown', () => {
    pointerMode = true;
}, { capture: true, passive: true });
document.addEventListener('keydown', () => {
    pointerMode = false;
}, { capture: true, passive: true });
document.addEventListener('focusin', (event) => {
    const target = event.target;
    if (!pointerMode || !(target instanceof HTMLElement) || target.matches(NATIVE_RING))
        return;
    target.setAttribute(MARKER, '');
}, { capture: true });
document.addEventListener('focusout', (event) => {
    if (event.target instanceof HTMLElement)
        event.target.removeAttribute(MARKER);
}, { capture: true });
